export default __webpack_public_path__ + "9128ace7efc6ebd176f9060a021a04f8.png";